import axios from "axios";
import { replaceAllSbDomainsWithAkasa } from "@/utils/akasaDomainConverters/replaceSbDomainWithAkasa";
import { BASE_URL } from "../config/api_collection";
import { getToken } from "../helper/token";
import { currentSBVersion } from "../services/storyBlokVersionUpdate";
import { StoryblokConfig } from "../config/storyblok";

const STORYBLOK_ADDON_DETAILS = `https://api.storyblok.com/v1/cdn/stories/add-on/add-on?version=published&token=${StoryblokConfig.accessToken}`;
const STORYBLOK_MEAL_LIST = `https://api.storyblok.com/v1/cdn/stories/add-on/meals?version=published&token=${StoryblokConfig.accessToken}`;
const BOOKING_SSRS = `${BASE_URL}/api/nsk/v2/booking/ssrs`;

export async function getAddOnDetails() {
  try {
    const cv = await currentSBVersion();
    const res = await axios.get(`${STORYBLOK_ADDON_DETAILS}&cv=${cv}`);
    const responseWithUpdatedDomainName = replaceAllSbDomainsWithAkasa({ dataToUpdate: res?.data });
    return responseWithUpdatedDomainName;
  } catch (error) {
    console.warn(error);
  }
}

export async function getMealsList() {
  try {
    const cv = await currentSBVersion();
    const res = await axios.get(`${STORYBLOK_MEAL_LIST}&cv=${cv}`);
    const responseWithUpdatedDomainName = replaceAllSbDomainsWithAkasa({ dataToUpdate: res?.data });
    return responseWithUpdatedDomainName;
  } catch (error) {
    console.warn(error);
  }
}

export async function setPlusAddons(ssrKey: string) {
  try {
    const url = `${BOOKING_SSRS}/${ssrKey}`;
    const tokenHeaders = await getToken();
    tokenHeaders["Content-Type"] = "application/json";
    tokenHeaders.Accept = "application/json";
  
    const res = await axios.post(
      url,
      {
        count: 1,
        currencyCode: "ÏNR",
        ssrSellMode: 2,
        feePricingMode: 0
      },
      { headers: tokenHeaders }
    );
  
    return res.data;
  } catch (error) {
    console.warn(error);
  }

}
